module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-113.1e8f9b3.woff2";